import { breakpoints } from "styles";
import styled from "styled-components";

export const LogoWrapper = styled.div`
  position: relative;
  width: 120px;
  height: 26px;
  cursor: pointer;

  @media ${breakpoints.tablet} {
    width: 120px;
    height: 30px;
  }

  @media ${breakpoints.mobile} {
    width: 103px;
    height: 22px;
  }
`;
